import { useStyles } from '@archipro-design/aria';
import * as S from './VariantPurchase.style';
import QuantityGroup from './QuantityGroup';
import StockAndShipping from './StockAndShipping';

const VariantPurchase = ({
    whereToBuyEnabled,
    onClickWhereToBuy,
}: {
    whereToBuyEnabled?: boolean;
    onClickWhereToBuy?: () => void;
}) => {
    const { css } = useStyles();
    return (
        <div className={css(S.VariantPurchase)}>
            <StockAndShipping />
            <QuantityGroup
                whereToBuyEnabled={whereToBuyEnabled}
                onClickWhereToBuy={onClickWhereToBuy}
            />
        </div>
    );
};

export default VariantPurchase;
